// File moved to ./worker/cache.js
// TODO: Remove this backward-compat "proxy file" in Babel 8
module.exports = require("./worker/cache");
